import { isEqual } from 'lodash';
import { TOAST } from '../actionTypes';
import { deepClone } from '../../utils/global_functions';
import { v4 as uuidv4 } from 'uuid';
export const showToast = (payload) => {
    return { type: TOAST.HANDLE_TOAST, payload }
}
export const removeToast=(payload)=>{
   return { type: TOAST.REMOVE_TOAST, payload }
}
export const toastConfig = (payload) => (dispatch, getState) => {
  const id = uuidv4();
  const toasts = getState()?.toasts?.toasts;
  if(payload.show)
    dispatch(showToast({ ...payload, id: id }))
  else{
    if(payload.id){
      dispatch(removeToast(payload.id))
    }
    else{
      dispatch(removeToast(toasts[toasts.length-1]?.id))
    }
  }
};



export const updateToastChildrenData = (objToRemove) => async (dispatch,getState) => {
   const childrenDataArray = deepClone(getState()?.toasts?.childrenData)

 
   let removeObjIndex

   for(let i=0; i< childrenDataArray.length; i++ ){
    removeObjIndex = i
      if(isEqual(childrenDataArray[i],objToRemove)){ 
        break;
      }
   }

  
    childrenDataArray.splice(removeObjIndex,1)
    dispatch(handleToastChildrenData([...childrenDataArray]))
   
 
}


  export const handleToastChildrenData = (payload)=>{
      return {type:TOAST.HANDLE_CHILDREN_DATA, payload}
  }